/**
 * Device / 연결·패킷 API 에러 → i18n 키만 담은 ErrorMessage
 */

import {
  getBackendI18nKeyFromResponse,
  getHttpStatus,
  getServerMessage,
  isNetworkError,
  looksLikeI18nKey,
  normalizeBackendI18nKey,
} from './apiError';
import type { ErrorMessage } from './types';

const DEVICE_ERRORS = {
  GENERIC: {
    title: 'device:loadFailed',
    message: 'device:loadFailedDesc',
    type: 'error' as const,
  },
} as const;

export function parseDeviceApiError(error: unknown): ErrorMessage {
  if (!error) {
    return DEVICE_ERRORS.GENERIC;
  }

  if (isNetworkError(error)) {
    return {
      title: 'auth:network_error',
      message: 'auth:network_error_message',
      type: 'error',
    };
  }

  const fromBackend = getBackendI18nKeyFromResponse(error);
  if (fromBackend && looksLikeI18nKey(fromBackend)) {
    return {
      title: 'device:loadFailed',
      message: normalizeBackendI18nKey(fromBackend),
      type: 'error',
    };
  }

  const rawMsg = getServerMessage(error);
  if (rawMsg && looksLikeI18nKey(rawMsg)) {
    return {
      title: 'device:loadFailed',
      message: normalizeBackendI18nKey(rawMsg),
      type: 'error',
    };
  }

  switch (getHttpStatus(error)) {
    case 403:
      return {
        title: 'device:loadFailed',
        message: 'device:deviceInfoFailedDesc',
        type: 'error',
      };
    case 404:
      return {
        title: 'device:loadFailed',
        message: 'device:deviceInfoFailedDesc',
        type: 'error',
      };
    case 409:
      return {
        title: 'device:loadFailed',
        message: 'device:loadFailedDesc',
        type: 'error',
      };
    case 500:
      return {
        title: 'device:loadFailed',
        message: 'device:loadFailedDesc',
        type: 'error',
      };
    default:
      return DEVICE_ERRORS.GENERIC;
  }
}
